import Intercom from "@intercom/messenger-js-sdk";
import { getConfig } from "./environment.ts";

export type IntercomArticle =
  | "change_part_of_your_image"
  | "create_a_new_image_from_a_sketch"
  | "generate_with_two_characters_models"
  | "get_variations_of_your_image"
  | "improve_the_quality_of_generated_images"
  | "quick_upscale_and_enhance_your_images"
  | "generate_from_a_brief";

export const initIntercom = ({
  userUuid,
  userEmail,
  userName,
  userCreatedAt,
  userHash,
}: {
  userUuid: string;
  userEmail: string;
  userName: string;
  userCreatedAt: string;
  userHash: string;
}) => {
  // XXX: We use same testing workspace between dev and staging as Intercom allows a single one
  const appId = getConfig({
    dev: "d5mxodf2",
    staging: "d5mxodf2",
    prod: "q1mqyn3x",
  });

  Intercom({
    app_id: appId,
    user_id: userUuid,
    email: userEmail,
    name: userName,
    created_at: Math.floor(new Date(userCreatedAt).getTime() / 1000),
    user_hash: userHash,
  });
};

export const openIntercomArticleInMessenger = (articleId: IntercomArticle) => {
  window.Intercom?.(
    "showArticle",
    // XXX: As we don't have same article ids in our test help center, we use the same one for dev and staging to avoid
    // having to synchronize both help centers
    getConfig({
      dev: 10324355,
      staging: 10324355,
      prod: ARTICLE_IDS[articleId],
    }),
  );
};

const ARTICLE_IDS: Record<IntercomArticle, number> = {
  change_part_of_your_image: 10703972,
  create_a_new_image_from_a_sketch: 10703104,
  generate_with_two_characters_models: 10738251,
  get_variations_of_your_image: 10701931,
  improve_the_quality_of_generated_images: 10706048,
  quick_upscale_and_enhance_your_images: 10706126,
  generate_from_a_brief: 11032521,
};
